<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationNoList"
          :value.sync="queryParams.organizationNoList"
          selectType="selectAssembleMultiple"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
        />
        <global-select
          ref="apptsNoListRef"
          slot="apptsNoList"
          :value.sync="queryParams.apptsNoList"
          selectType="selectMultipleSearch"
          requestApi="/plan/appointment/appts/getApptsNoBox"
          :selectItem="{ value: 'label', label: 'label' }"
          searchParam="apptsNo"
          :setParams="{ 'desOrganizationCode': organizationCodeOrigin }"
        />
        <global-select
          ref="supplierCodeRef"
          slot="supplierCodeList"
          :value.sync="queryParams.supplierCodeList"
          selectType="selectMultipleSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierNameList"
          :selectItem="{ value: 'label', label: 'realValue' }"
          searchParam="supplierName"
        />
        <global-select
          slot="apptsStatusList"
          :value.sync="queryParams.apptsStatusList"
          :selectData="statusList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
        />
        <global-select
          slot="materialTypeCodeList"
          :value.sync="queryParams.materialTypeCodeList"
          :selectData="materialTypeList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
        />
        <global-select
          slot="dockCodeList"
          :value.sync="queryParams.dockCodeList"
          :selectData="dockCodeList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
        />
        <global-select
          slot="deliverLiftCodeList"
          :value.sync="queryParams.deliverLiftCodeList"
          :selectData="deliverLiftList"
          selectType="selectMultipleFilter"
          :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
        />
        <global-select
          ref="receiveSupplierCodeListRef"
          slot="receiveSupplierCodeList"
          :value.sync="queryParams.receiveSupplierCodeList"
          selectType="selectMultipleSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierNameList"
          :selectItem="{ value: 'label', label: 'realValue' }"
          searchParam="supplierName"
          :setParams="{ 'supplierClassList': [15, 20] }"
        />
        <a-select slot="isExpectDelayLeave" v-model="queryParams.isExpectDelayLeave" allowClear>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiExportApptsList" ref="download" />
        <a-button type="primary" :loading="loading" v-hasPermi="['plan:appointment:export']" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1" v-hasPermi="['plan:appointment:submit']" @click="handleOperation('submit')">审核</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1" v-hasPermi="['plan:appointment:cancel']" @click="handleOperation('cancel')">取消</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1" v-hasPermi="['plan:appointment:reject']" @click="handleReject">驳回</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1" v-hasPermi="['plan:appointment:takeEffect']" @click="handleTakeEffect">生效</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1" v-hasPermi="['plan:appointment:retract']" @click="handleRetract">撤销</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1" v-hasPermi="['plan:appointment:appointmentTime']" @click="handleAppointmentTime">可预约时间段查看</a-button>
        <reject-modal ref="rejectModalRef" @closeModal="handleOk(true)" />
        <appointment-time-modal ref="appointmentTimeModalRef" :deliverLiftList="deliverLiftList" @closeModal="handleOk(true)" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="apptsNo" slot-scope="{ record, text }">
            <a @click="toDetails(record)" href="javascript:;">{{ text }}</a>
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <!-- 物料类型 -->
          <template slot="materialTypeCodeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              class="pub-select"
              :value.sync="record.materialTypeCode"
              :selectData="materialTypeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <!-- 月台 -->
          <template slot="dockCodeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              class="pub-select"
              :value.sync="record.dockCode"
              :selectData="dockCodeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <!-- 送货电梯 -->
          <template slot="deliverLift" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              class="pub-select"
              :value.sync="record.deliverLiftCode"
              :selectData="deliverLiftList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <!-- 车辆类型 -->
          <template slot="licenseTypeCodeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              :value.sync="record.licenseTypeCode"
              :selectData="licenseTypeCodeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <!-- 收货工厂 -->
          <template slot="receiveSupplierName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              class="pub-select"
              :value.sync="record.receiveSupplierCode"
              selectType="selectSearch"
              requestApi="/mdm/mdmOrgSupplier/supplierNameList"
              :selectItem="{ value: 'label', label: 'realValue' }"
              :dropdown-match-select-width="false"
              searchParam="supplierName"
              :setParams="{ 'supplierClassList': [15, 20] }"
              @change="(val, data)=>receiveSupplierChange(val, data, record)"
            />
          </template>
          <!-- 司机 -->
          <template slot="userName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              :dropdown-match-select-width="false"
              class="pub-select"
              :value.sync="record.userName"
              requestApi="/plan/appointment/appts/getDriverUserInfoList"
              selectType="selectSearch"
              searchParam="userName"
              :setParams="{ desOrganizationCode: organizationCodeOrigin }"
              :selectItem="{ value: 'id', label: 'userName' }"
              @change="(val, data)=>userNameChange(val, data, record)"
            />
          </template>
          <!-- 车辆类型 -->
          <template slot="licenseTypeCodeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              class="pub-select"
              :value.sync="record.licenseTypeCode"
              :selectData="licenseTypeCodeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <!-- 车辆大小 -->
          <template slot="licenseSizeCodeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <global-select
              v-else
              :allowClear="false"
              class="pub-select"
              :value.sync="record.licenseSizeCode"
              :selectData="licenseSizeCodeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
            />
          </template>
          <!-- 车牌号码 -->
          <template slot="licenseNo" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <a-input v-else v-model="record.licenseNo" placeholder="请输入" :maxLength="50" />
          </template>
          <!-- 预约入园时间 -->
          <template slot="fmApptsTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <a-date-picker
              style="min-width: 160px"
              v-else
              :allowClear="false"
              :show-time="{format: 'HH:mm'}"
              v-model="record.fmApptsTime"
              format="YYYY-MM-DD HH:mm:00"
              valueFormat="YYYY-MM-DD HH:mm:00"
            />
          </template>
          <!-- 预约出园时间 -->
          <template slot="toApptsTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave === 1">{{ text }}</span>
            <a-date-picker
              style="min-width: 160px"
              :allowClear="false"
              v-else
              :show-time="{format: 'HH:mm'}"
              v-model="record.toApptsTime"
              format="YYYY-MM-DD HH:mm:00"
              valueFormat="YYYY-MM-DD HH:mm:00"
            />
          </template>
          <!-- 异常备注 -->
          <template slot="exceptionRemark" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id || record.isExpectDelayLeave !== 1">{{ text }}</span>
            <a-input v-else v-model="record.exceptionRemark" placeholder="请输入" :maxLength="200" />
          </template>
          <span slot="operation" slot-scope="text">
            <!--待提交和已超时出园的可编辑，但已超时出园的只能编辑异常备注-->
            <a
              v-if="(!isEdit || currentId !== text.record.id) && (text.record.apptsStatus === 5 || text.record.isExpectDelayLeave === 1)"
              v-hasPermi="['plan:appointment:edit']"
              @click="handleEdit(text.record)">
              编辑
            </a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import {
  apiExportApptsList,
  apiGetAppAuditAppts,
  apiGetAppRetractAppts,
  apiGetAppCancelAppts,
  apiGetAppEnableAppts,
  apiGetAppMaterialList,
  apiModifyAppts
} from '@/api/scp/materialReservationManagement/materialReservation'
import rejectModal from './components/reject-modal.vue'
import appointmentTimeModal from './components/appointment-time-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'
import { mapState } from 'vuex'

export default {
  name: 'MaterialReservationList',
  components: { DownloadModal, rejectModal, appointmentTimeModal },
  mixins: [cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      apiExportApptsList,
      loading: false, // 请求loading
      isEdit: false,
      currentId: "",
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetAppMaterialList, false),
        pageCurrent: true
      },
      statusList: [], // 状态列表
      materialTypeList: [], // 物料类型列表
      dockCodeList: [], // 月台列表
      deliverLiftList: [], // 送货电梯列表
      licenseTypeCodeList: [], // 车辆类型列表
      licenseSizeCodeList: [], // 车辆大小列表
      // 查询参数
      queryParams: {
        organizationNoList: undefined,
        apptsNo: undefined,
        materialTypeCodeList: undefined,
        supplierCodeList: undefined,
        apptsStatusList: undefined,
        apptsTime: undefined,
        startApptsTime: undefined,
        endApptsTime: undefined,
        dockCodeList: undefined,
        deliverLiftCodeList: undefined,
        apptsNoList: undefined,
        receiveSupplierCodeList: undefined,
        isExpectDelayLeave: undefined,
        licenseNo: undefined
      },
      formList: [
        { label: '加工厂', decorator: ['organizationNoList'], type: 'organizationNoList' },
        { label: '预约单号', decorator: ['apptsNoList'], type: 'apptsNoList' },
        { label: '物料类型', decorator: ['materialTypeCodeList'], type: 'materialTypeCodeList' },
        { label: '材料商', decorator: ['supplierCodeList'], type: 'supplierCodeList' },
        { label: '状态', decorator: ['apptsStatusList'], type: 'apptsStatusList' },
        {
          label: '计划入园时间段',
          type: 'range',
          decorator: ['apptsTime'],
          disposeFormat: {
            startApptsTime: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endApptsTime: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '月台', decorator: ['dockCodeList'], type: 'dockCodeList' },
        { label: '送货电梯', decorator: ['deliverLiftCodeList'], type: 'deliverLiftCodeList' },
        { label: '收货工厂', decorator: ['receiveSupplierCodeList'], type: 'receiveSupplierCodeList' },
        { label: '是否超时出园', decorator: ['isExpectDelayLeave'], type: 'isExpectDelayLeave' },
        { label: '车牌号', decorator: ['licenseNo'], type: 'input' }
      ],
      // 表格字段
      columns: [
        { title: '预约单号', dataIndex: 'apptsNo', scopedSlots: { customRender: 'apptsNo' }, align: 'center', width: 140 },
        { title: '加工厂编码', dataIndex: 'organizationNo', align: 'center', width: 100 },
        { title: '加工厂名称', dataIndex: 'organizationName', align: 'center', width: 120 },
        { title: '物料类型', dataIndex: 'materialTypeCodeName', scopedSlots: { customRender: 'materialTypeCodeName' }, align: 'center', width: 100 },
        { title: '驳回备注', dataIndex: 'remark', align: 'center', width: 160, ellipsis: true },
        { title: '月台', dataIndex: 'dockCodeName', scopedSlots: { customRender: 'dockCodeName' }, align: 'center', width: 95 },
        { title: '送货电梯', dataIndex: 'deliverLift', scopedSlots: { customRender: 'deliverLift' }, align: 'center', width: 100 },
        { title: '材料商编码', dataIndex: 'supplierCode', align: 'center', width: 100 },
        { title: '材料商名称', dataIndex: 'supplierName', align: 'center', width: 140 },
        { title: '收货工厂', dataIndex: 'receiveSupplierName', scopedSlots: { customRender: 'receiveSupplierName' }, align: 'center', width: 180 },
        { title: '司机', dataIndex: 'userName', scopedSlots: { customRender: 'userName' }, align: 'center', width: 120 },
        { title: '司机电话', dataIndex: 'userTel', align: 'center', width: 120 },
        { title: '车辆类型', dataIndex: 'licenseTypeCodeName', scopedSlots: { customRender: 'licenseTypeCodeName' }, align: 'center', width: 110 },
        { title: '车辆大小', dataIndex: 'licenseSizeCodeName', scopedSlots: { customRender: 'licenseSizeCodeName' }, align: 'center', width: 100 },
        { title: '车牌号码', dataIndex: 'licenseNo', scopedSlots: { customRender: 'licenseNo' }, align: 'center', width: 110 },
        // { title: '按时', dataIndex: 'isOnTime', align: 'center', width: 90 },
        { title: '预约入园时间', dataIndex: 'fmApptsTime', scopedSlots: { customRender: 'fmApptsTime' }, align: 'center', width: 165 },
        { title: '预约出园时间', dataIndex: 'toApptsTime', scopedSlots: { customRender: 'toApptsTime' }, align: 'center', width: 165 },
        { title: '预约时长（分钟）', dataIndex: 'apptDuration', align: 'center', width: 140 },
        { title: '实际入园时间', dataIndex: 'arriveTime', align: 'center', width: 140 },
        { title: '实际出园时间', dataIndex: 'leaveTime', align: 'center', width: 140 },
        { title: '入园时差（分钟）', dataIndex: 'arriveTimeDiff', align: 'center', width: 140 },
        { title: '出园时差（分钟）', dataIndex: 'leaveTimeDiff', align: 'center', width: 140 },
        { title: '卸货时长（分钟）', dataIndex: 'unloadDuration', align: 'center', width: 140 },
        { title: '是否超时出园', dataIndex: 'isExpectDelayLeaveName', align: 'center', width: 140 },
        { title: '异常备注', dataIndex: 'exceptionRemark', scopedSlots: { customRender: 'exceptionRemark' }, align: 'center', width: 200 },
        { title: '单据创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '单据状态', dataIndex: 'apptsStatusName', align: 'center', width: 90 },
        { title: '创建人', dataIndex: 'createUserName', align: 'center', width: 90 },
        { title: '创建人电话', dataIndex: 'createUserTel', align: 'center', width: 100 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('MINI_PROGRAM_MATERIAl_TYPE', { lookupType: 'MINI_PROGRAM_MATERIAl_TYPE', current: 1, pageSize: 999 }, 'materialTypeList')
    this.cacheLookupRequest('MINI_PROGRAM_APPTS_STATUS', { lookupType: 'MINI_PROGRAM_APPTS_STATUS', current: 1, pageSize: 999 }, 'statusList')
    this.cacheLookupRequest('MINI_PROGRAM_RAILWAY_PLATFORM', { lookupType: 'MINI_PROGRAM_RAILWAY_PLATFORM', current: 1, pageSize: 999 }, 'dockCodeList')
    this.cacheLookupRequest('MINI_PROGRAM_RECEIVE_LIFT', { lookupType: 'MINI_PROGRAM_RECEIVE_LIFT', current: 1, pageSize: 999 }, 'deliverLiftList')
    this.cacheLookupRequest('MINI_PROGRAM_LICENSE_TYPE', { lookupType: 'MINI_PROGRAM_LICENSE_TYPE', current: 1, pageSize: 999 }, 'licenseTypeCodeList')
    this.cacheLookupRequest('MINI_PROGRAM_LICENSE_SIZE', { lookupType: 'MINI_PROGRAM_LICENSE_SIZE', current: 1, pageSize: 999 }, 'licenseSizeCodeList')
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 跳转到详情页面
    toDetails (record) {
      this.$router.push({ name: `MaterialReservationDetail`, query: { apptsNo: record.apptsNo } })
    },
    // 司机变化
    userNameChange(val, data, record) {
      if(val && data?.length > 0) {
        const getUser = data?.find(item => item?.id === val)
        record.userId = getUser?.id // 更新司机id
        record.userName = getUser?.userName // 更新司机名称
        record.userTel = getUser?.userTel // 更新司机电话
      } else {
        record.userId = ''
        record.userName = ''
        record.userTel = ''
      }
    },
    // 收货工厂
    receiveSupplierChange(val, data, record) {
      if(val && data?.length > 0) {
        const getData = data?.find(item => item?.label === val)
        record.receiveSupplierCode = getData?.label
        record.receiveSupplierName = getData?.realValue
      } else {
        record.receiveSupplierCode = ''
        record.receiveSupplierName = ''
      }
    },
    // 查看预约时间
    handleAppointmentTime() {
      if(this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据')
        return
      }
      if(this.selectedRows.length > 1) {
        this.$message.warning('请勾选单个数据')
        return
      }
      this.$refs.appointmentTimeModalRef.show(this.selectedRows[0])
    },
    // 操作方法
    handleOperation(operate) {
      const operateType = {
        submit: { text: '审核', apiRequest: apiGetAppAuditAppts },
        cancel: { text: '取消', apiRequest: apiGetAppCancelAppts }
      }
      if(operate === 'submit' && this.selectedRows.find(item => item.apptsStatus !== 5)) {
        this.$message.warning(`请选择待审核单据审核`)
        return;
      }
      if(operate === 'cancel' && this.selectedRows.find(item => item.apptsStatus !== 1 && item.apptsStatus !== 6)) {
        this.$message.warning(`请选择待入园、已驳回单据取消`)
        return;
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: `确定${operateType[operate].text}勾选的单据吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const apptsNoList = self.selectedRows.map(item => item.apptsNo)
            operateType[operate].apiRequest({ apptsNoList: apptsNoList }).then(res => {
            if (res?.code === 200) {
              self.$message.success(`${operateType[operate].text}成功`)
              self.handleOk(true)
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 生效
    handleTakeEffect() {
      // console.log(this.selectedRows)
      if(this.selectedRows?.length < 1) {
        this.$message.warning('请勾选数据')
        return
      }
      if(this.selectedRows.find(item => item?.apptsStatus !== 7)) {
        this.$message.warning('请勾选已失效单据操作')
        return
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: `勾选单据确定执行生效吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const params = {
            apptsNoList: this.selectedRows.map(item => item.apptsNo)
          }
          apiGetAppEnableAppts(params).then(res => {
            if (res?.code === 200) {
              self.$message.success(`执行生效成功`)
              self.handleOk(true)
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 驳回
    handleReject() {
      const findNoAllow = this.selectedRows.find(item => item.apptsStatus !== 5)
      if(findNoAllow) {
        this.$message.warning('请选择待审核单据驳回')
        return;
      }
      this.$refs.rejectModalRef.show(this.selectedRows);
    },
    // 撤销
    handleRetract() {
      const findNoAllow = this.selectedRows.find(item => item.apptsStatus !== 1)
      if(findNoAllow) {
        this.$message.warning('请选择单据状态为“待入园”的单据撤销')
        return;
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: `确定撤销勾选的单据吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const apptsNoList = self.selectedRows.map(item => item.apptsNo)
            apiGetAppRetractAppts({ apptsNoList: apptsNoList }).then(res => {
            if (res?.code === 200) {
              self.$message.success(`撤销成功`)
              self.handleOk(true)
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      if(!record?.licenseNo) {
        this.$message.warning('请输入车牌号码')
        return;
      }
      this.loading = true;
      apiModifyAppts(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('编辑成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      params.desOrganizationCode = this.organizationCodeOrigin // 当前组织
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationNoList: undefined,
        apptsNo: undefined,
        materialTypeCodeList: undefined,
        supplierCodeList: undefined,
        apptsStatusList: undefined,
        apptsTime: undefined,
        startApptsTime: undefined,
        endApptsTime: undefined,
        dockCodeList: undefined,
        deliverLiftCodeList: undefined,
        apptsNoList: undefined,
        receiveSupplierCodeList: undefined,
        isExpectDelayLeave: undefined,
        licenseNo: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      if(this.$refs?.supplierCodeRef) this.$refs.supplierCodeRef.handleSearch('');
      if(this.$refs?.apptsNoListRef) this.$refs.apptsNoListRef.handleSearch('');
      if(this.$refs?.receiveSupplierCodeListRef) this.$refs.receiveSupplierCodeListRef.handleSearch('');
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select{
  /deep/ .ant-select{
    width: 100%;
  }
}
</style>
